import * as React from "react";

import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./common/PrivateRoute";
import PrivateRouteProject, {
  VerifySession,
} from "./common/PrivateRouteProject";

import Development from "./modules/development/components/pages/Development";
import RateLibrary from "./modules/rateLibrary/components/pages/RateLibrary";
import Settings from "./modules/profile/components/pages/Settings";
import Menu from "modules/menu/components/pages/Menu";
import Composition from "modules/composition/components/pages/Composition";
import LogIn from "modules/login/components/pages/Login";
import ResetAndVerify from "modules/account/components/pages/ResetAndVerify";
import CheckEmail from "./modules/login/components/pages/CheckEmail";

const RateLibraryRoute = () => (
  <React.Fragment>
    <Route
      exact
      path="/menu/rateLibraries"
      render={() => <VerifySession render={() => <RateLibrary />} />}
    />
    <Route
      path="/menu/rateLibraries/:id"
      children={({ match }) =>
        match && <VerifySession render={() => <Composition match={match} />} />
      }
    />
  </React.Fragment>
);

const MenuRouter = () => (
  <Menu>
    <Route exact path="/menu/development" component={Development} />
    <Route path="/menu/rateLibraries" component={RateLibraryRoute} />
    <Route
      exact
      path="/menu/profile"
      render={() => <VerifySession render={() => <Settings />} />}
    />
    <Route exact path="/menu" component={Development} />
  </Menu>
);

const Pages = () => (
  <React.Fragment>
    <Route path="/menu" component={MenuRouter} />
    <Route exact path="/check-email" component={CheckEmail} />
    <Route path="/:id([0-9a-zA-Z]{20})" component={PrivateRouteProject} />
  </React.Fragment>
);

const Routers = () => (
  <main>
    <Switch>
      <Route exact path="/" component={LogIn} />
      <Route exact path="/login" component={LogIn} />
      <Route exact path="/register" component={LogIn} />
      <Route exact path="/account" component={ResetAndVerify} />
      <PrivateRoute Component={Pages} />
    </Switch>
  </main>
);

export default Routers;



// WEBPACK FOOTER //
// ./src/Routes.tsx